<template>
    <section class="page-section page-section--first page-section--last">
        <business-heading />
        <business-tabs v-model="tab" :titles="tabTitles" />
        <business-section-0 v-if="tab == tabTitles[0]" />
        <business-section-1 v-if="tab == tabTitles[1]" />
        <business-section-2 v-if="tab == tabTitles[2]" />
    </section>
</template>

<script>
import BusinessHeading from "./business-heading.vue";
import BusinessSection0 from "./business-section-0.vue";
import BusinessSection1 from "./business-section-1.vue";
import BusinessSection2 from "./business-section-2.vue";
import BusinessTabs from "./business-tabs.vue";

const tabTitles = ["전자혁신 제조지원 사업", "스마트전자 확산, 제조실증 기반구축", "데이터분석기반 전자제조"];

export default {
    components: { BusinessHeading, BusinessTabs, BusinessSection0, BusinessSection1, BusinessSection2 },
    data() {
        return {
            tab: tabTitles[0],
            tabTitles,
        };
    },
};
</script>

<style></style>
